import $ from "jquery";
import { Klass, u_, csl } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "../klass.VuwForm";

const ACCEPTS = {
	"img": "image/*",
	"pdf": ".pdf",
	"video": "video/*",
	"office": ".doc, .docx, .xls, .xlsx, .ppt, .pptx",
	"csv": ".csv"
}

/**
 * VuwFileUploader for VuwFileset (extends VuwForm)
 * @options
 * - @required {String} dataType
 * - @required {String} inpFileName
 * - {String} inpFileId
 * - {Number} maxFileSize
 * - {Array} regardAsFlv: for video
 * - {Array} allowTypes: for mix
 * - {Function} begin
 * - {Function} onError
 * - {Function} onSelect
 * - {Function} onDisSelect
 * - {Function} onFileRead
 * - {Function} onUpload
 */
vuwer.appendKlass("VuwFileUploader", {
	dataType: false,
	inpFileName: false,
	
	fileTypeConfig: {
		img: {
			ftypeIdx: 0,
			typeRegExp: /^image/i,
			message: "画像ファイルを選択して下さい"
		},
		video: {
			ftypeIdx: 0,
			typeRegExp: /^video/i,
			message: "動画ファイルを選択して下さい"
		},
		pdf: {
			ftypeIdx: 1,
			typeRegExp: /^pdf/i,
			message: "PDFファイルを選択して下さい"
		},
		office: {
			ftypeIdx: 1,
			typeRegExp: /^vnd\.|^msword/i,
			message: "許可されていないファイル形式です"
		},
		csv: {
			ftypeIdx: 1,
			typeRegExp: /^plain|^csv|^vnd\./i,
			message: "CSVファイルを選択して下さい"
		}
	},
	
	// callbacks
	begin($form) {},
	onError(error) {},
	onSelect(selectedFilePath, selectedFileName) {},
	onDisSelect(paramKey) {},
	onFileRead(ulFile, res) {},
	onUploadn(res) {},
	
	_initialize(opt) {
		const _super_ = Klass("VuwFileUploader").parent._initialize.bind(this);
		if( !_super_(opt) ) {
			return false;
		}
		
		if(!this.dataType) {
			csl.warn(`${this.getAddress()}._initialize() ... no dataType.`);
			return false;
		}
		
		if(
			Object.keys(this.fileTypeConfig).indexOf(this.dataType) < 0 &&
			this.dataType !== "mix"
		) {
			csl.warn(
				`${this.getAddress()}._initialize() ... undefined dataType.`,
				this.dataType
			);
			return false;
		}
		
		if(!this.inpFileName) {
			csl.warn(`${this.getAddress()}._initialize() ... no inpFileName.`);
			return false;
		}
		
		this.setProp({
			selector() {
				return $("<form/>").addClass("vuw-file-uploader").attr({
					"data-name": this.inpFileName
				}).appendTo( this.getWrapper() );
			}
		})
		
		if( u_.isNumber(this.maxFileSize) ) {
			this.maxFileSizeTxt = u_.fileSizeToString(this.maxFileSize);
		}
		
		if(this.dataType === "mix") {
			this.accept = Object.keys(ACCEPTS).map(k => ACCEPTS[k]).join(",");
			
		} else {
			this.accept = ACCEPTS[this.dataType];
		}
		
		if( this.dataType === "video" && !Array.isArray(this.regardAsFlv) ) {
			this.regardAsFlv = [];
		}
		
		this.onReady(this._setUpEventListeners);
		return this;
	},
	
	/**
	 * イベントリスナーの設定など
	 * @param {$object} $self
	 * @returns this
	 */
	_setUpEventListeners($self) {
		!!$self && $self.on("change", ".inp-file", e => {
			const { files, value } = e.currentTarget;
			const file = (File && files.length) && files.item(0);
			this.onFileChange(value, file || undefined);
		});
		
		this.refresh();
	},
	
	getWrapper(as$) {
		if(!Klass("VuwFileUploader")._$wrapper) {
			// [create _$templateArea]
			Klass("VuwFileUploader")._$wrapper = $("<div/>").addClass(
				"vuw-file-uploader-area"
			).css({
				"overflow": "hidden",
				"position": "fixed",
				"height": 0,
				"width": 0,
				"z-index": -1
			}).appendTo(document.body);
		}
		
		if(as$ === false) {
			return Klass("VuwFileUploader")._$wrapper.get(0);
		}
		
		return Klass("VuwFileUploader")._$wrapper;
	},
	
	refresh() {
		const has = !!this.$inpFile;
		
		if(!this.isReady) {
			throw new Error(`${this.getAddress()} is not ready.`);
		}
		
		has && this.$inpFile.remove();
		delete this.currentFileName;
		
		this.$inpFile = $("<input/>").attr({
			type: "file",
			name: this.inpFileName,
			accept: this.accept
		}).addClass("inp inp-file").appendTo(this.$self);
		
		!!this.inpFileId && this.$inpFile.attr("id", this.inpFileId);
		
		// call onDisSelect
		has && this.onDisSelect(this.paramKey);
	},
	
	async onFileChange(filePath, fileData) {
		if(!filePath) {
			return false;
		}
		
		if( u_.isObject(fileData) ) {
			const { fileTypeConfig, dataType, maxFileSize, maxFileSizeTxt } = this;
			
			if(dataType === "mix") {
				let fileType;
				Object.keys(fileTypeConfig).forEach(t => {
					const typeConf = fileTypeConfig[t];
					if(
						u_.isObject(typeConf) &&
						fileData.type &&
						typeConf.typeRegExp.test(fileData.type.split("/")[typeConf.ftypeIdx])
					) {
						fileType = t;
					}
				});
				
				if(
					!fileType || (
						Array.isArray(this.allowTypes) &&
						this.allowTypes.indexOf(fileType) < 0
					)
				) {
					this.onError("許可されていないファイル形式です", null, fileData);
					return false;
				}
			}
			
			const typeConf = fileTypeConfig[dataType];
			if(
				u_.isObject(typeConf) &&
				fileData.type &&
				!typeConf.typeRegExp.test(fileData.type.split("/")[typeConf.ftypeIdx])
			) {
				csl.log.red("disallow file type", fileData.type);
				this.onError(typeConf.message, null, fileData);
				return false;
				
			}
			
			if( u_.isNumber(maxFileSize) && fileData.size > maxFileSize) {
				csl.log.red("file size over", {
					selectedFile: fileData.size,
					maxFileSize
				});
				
				this.onError(`ファイルサイズは${maxFileSizeTxt}以下にして下さい`, null, fileData);
				return false;
			}
			
			this.currentFileName = fileData.name;
			
			// call onSelect
			await this.onSelect(filePath, fileData.name);
			
			if(
				this.dataType !== "video" ||
				this.regardAsFlv.indexOf( fileData.name.split(".").slice(-1)[0] ) < 0
			) {
				await new Promise(resolve => {
					const fr = new FileReader();
					fr.onload = async (...args) => {
						await this.onFileRead(fileData, fr.result, args);
						resolve();
					};
					// エラーの場合もresolve
					fr.onerror = resolve;
					fr.readAsDataURL(fileData);
				});
			}
			
		} else {
			// for legacy IE
			fileData = filePath.split("\\");
			fileData.len = fileData.length;
			fileData = {
				name: !!fileData.len ? fileData[fileData.len - 1] : filePath
			};
			
			this.currentFileName = fileData.name;
			
			// call onSelect
			await this.onSelect(filePath, fileData.name);
			
			// call onFileRead
			await this.onFileRead(fileData, false);
		}
		
		return this.aSubmit({
			methodName: "fileUpload",
			type: "POST",
			begin: this.begin,
			success: this.onUpload,
			error: this.onError
		});
	},
	
	getClosestField() {
		if(this.container) {
			if( this.container instanceof Klass("VuwField") ) {
				return this.container;
			} else {
				return Klass("VuwFileUploader").prototype.getClosestField.call(this.container);
			}
		} else {
			return false;
		}
	}
}, "VuwForm");
